module.exports = __webpack_public_path__ + "static/media/ice31.23c6cb6e.webp";